import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.$route.params.id && _vm.originalUser ? _c(VContainer, {
    staticClass: "pa-0",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    staticClass: "user-form",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_vm.tenantDetails ? _c('core-header', {
    attrs: {
      "headline": `${_vm.$i18n_t('Common.userEditHead')}: ${_vm.editedUser.firstName || ''} ${_vm.editedUser.lastName || ''}`,
      "formIsValid": _vm.valid,
      "isSaving": _vm.isLoading,
      "isLoading": _vm.isLoading,
      "buttons": _vm.headerButtons
    },
    on: {
      "saveData": _vm.handleSubmit,
      "cancel": _vm.cancelUserEdit,
      "impersonate": function ($event) {
        return _vm.doImpersonateUser(_vm.editedUser);
      }
    }
  }) : _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.accMgmtHead')
    }
  }), _vm.tenantDetails ? _c(VRow, {
    staticClass: "pl-4 pb-4 pr-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VCardText, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-0 pt-0 pr-0 mr-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('h4', {
    staticClass: "pt-1"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Common.tenant')) + ":")])]), _c(VCol, {
    staticClass: "mt-0 pt-0 pl-0 ml-0",
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_vm.tenantDetails.ancestors.length ? _c(VBreadcrumbs, {
    staticClass: "px-2",
    attrs: {
      "items": _vm.tenantDetails.ancestors,
      "large": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VBreadcrumbsItem, {
          attrs: {
            "disabled": !item.disabled
          }
        }, [_vm._v("\n                      " + _vm._s(item.name.toUpperCase()) + "\n                    ")])];
      }
    }], null, false, 7338606)
  }) : _c('h4', {
    staticClass: "pl-3 pt-1"
  }, [_vm._v(_vm._s(_vm.tenantDetails.name))])], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "first_name",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.firstName'),
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "autofocus": ""
    },
    model: {
      value: _vm.editedUser.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser, "firstName", $$v);
      },
      expression: "editedUser.firstName"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "last_name",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.lastName'),
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser, "lastName", $$v);
      },
      expression: "editedUser.lastName"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "user_email",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.email'),
      "rules": _vm.emailRules,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.email,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser, "email", $$v);
      },
      expression: "editedUser.email"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('Common.active'),
      "color": _vm.color
    },
    model: {
      value: _vm.editedUser.active,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser, "active", $$v);
      },
      expression: "editedUser.active"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showAddressData ? _c(VExpansionPanels, {
    staticClass: "mb-4",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.contactPanel,
      callback: function ($$v) {
        _vm.contactPanel = $$v;
      },
      expression: "contactPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.contactInfo')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4"
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "mobile",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.mobile'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.contactInfo.mobile,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.contactInfo, "mobile", $$v);
      },
      expression: "editedUser.properties.contactInfo.mobile"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "phone",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.phone'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.contactInfo.phone,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.contactInfo, "phone", $$v);
      },
      expression: "editedUser.properties.contactInfo.phone"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "pt-1 pb-1",
    attrs: {
      "cols": "12",
      "md": "11"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.properties')))])])], 1), _vm._l(_vm.userKeyValue, function (kv, i) {
    return _c(VRow, {
      key: i,
      attrs: {
        "align": "center"
      }
    }, [_c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": "5"
      }
    }, [_c(VTextField, {
      staticStyle: {
        "height": "90px"
      },
      attrs: {
        "data-cy": _vm.dataCyFromPropertyKey(kv.key, 'user_property'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('accMgmt.user.propertyKey'),
        "rules": _vm.requiredRuleKeyValue(kv),
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.$refs['form'].validate();
        }
      },
      model: {
        value: kv.key,
        callback: function ($$v) {
          _vm.$set(kv, "key", $$v);
        },
        expression: "kv.key"
      }
    })], 1), _c(VCol, {
      staticClass: "pt-1 pb-1",
      attrs: {
        "cols": "12",
        "sm": "7"
      }
    }, [_c(VTextField, {
      staticStyle: {
        "height": "90px"
      },
      attrs: {
        "data-cy": _vm.dataCyFromPropertyKey(kv.key, 'property_value'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('accMgmt.user.propertyValue'),
        "rules": _vm.requiredRuleKeyValue(kv),
        "hide-details": "auto"
      },
      on: {
        "input": function ($event) {
          return _vm.$refs['form'].validate();
        }
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c(VBtn, {
            class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "data-cy": "add_KeyValuePair",
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.addNew'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.addKeyValuePair();
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1), _c(VBtn, {
            class: 'v-btn-x v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "data-cy": "delete_KeyValuePair",
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.removeKeyValuePair(i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1)];
        },
        proxy: true
      }], null, true),
      model: {
        value: kv.value,
        callback: function ($$v) {
          _vm.$set(kv, "value", $$v);
        },
        expression: "kv.value"
      }
    })], 1)], 1);
  }), _c(VRow, {
    attrs: {
      "align": "top"
    }
  }, [_c('p', {
    staticClass: "card-description mt-2 ml-3"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.titlePropertyFieldHint')))])]), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "py-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.accountMgmtPermissionsGroup')))])]), _c(VCol, {
    staticClass: "px-1 py-0",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('core-tenant-scopes-permissions-list', {
    attrs: {
      "loading": !_vm.editedUser.id && _vm.editedUser.access.length === 0,
      "userAccess": _vm.editedUser.access
    },
    on: {
      "updatedUserAccess": _vm.updatedUserAccess
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_vm.showAddressData ? _c(VExpansionPanels, {
    staticClass: "mb-4",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.addressPanel,
      callback: function ($$v) {
        _vm.addressPanel = $$v;
      },
      expression: "addressPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.address')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4"
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.street'),
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.street,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "street", $$v);
      },
      expression: "editedUser.properties.address.street"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.houseNumber'),
      "color": _vm.color,
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.houseNumber,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "houseNumber", $$v);
      },
      expression: "editedUser.properties.address.houseNumber"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.postalCode'),
      "color": _vm.color,
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.postalCode,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "postalCode", $$v);
      },
      expression: "editedUser.properties.address.postalCode"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.city'),
      "color": _vm.color,
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.city,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "city", $$v);
      },
      expression: "editedUser.properties.address.city"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.region'),
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.region,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "region", $$v);
      },
      expression: "editedUser.properties.address.region"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.country'),
      "type": "text",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.editedUser.properties.address.country,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties.address, "country", $$v);
      },
      expression: "editedUser.properties.address.country"
    }
  })], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm.uiThemes.length > 0 ? [_c(VCol, {
    staticStyle: {
      "padding-bottom": "2px"
    },
    attrs: {
      "cols": "12"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$i18n_t('Common.drawer.uiThemes')))])]), _c(VCol, {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.uiThemes,
      "item-value": "id",
      "item-text": "name",
      "hide-details": "auto"
    },
    model: {
      value: _vm.editedUser.properties.tenantIdThemeSetting,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser.properties, "tenantIdThemeSetting", $$v);
      },
      expression: "editedUser.properties.tenantIdThemeSetting"
    }
  })], 1)] : _vm._e(), _c(VExpansionPanels, {
    staticClass: "mb-4 mt-4",
    attrs: {
      "popout": ""
    },
    model: {
      value: _vm.idPanel,
      callback: function ($$v) {
        _vm.idPanel = $$v;
      },
      expression: "idPanel"
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', [_vm._v(_vm._s(_vm.$i18n_t('Common.tenantMoreDetails')))])]), _c(VExpansionPanelContent, [_c(VRow, {
    staticClass: "pa-4"
  }, [_c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "10",
      "xl": "9"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "user_id",
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.id'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": "",
      "disabled": ""
    },
    model: {
      value: _vm.editedUser.id,
      callback: function ($$v) {
        _vm.$set(_vm.editedUser, "id", $$v);
      },
      expression: "editedUser.id"
    }
  })], 1), _c(VCol, {
    staticClass: "pa-1",
    attrs: {
      "cols": "12",
      "md": "2",
      "xl": "3"
    }
  }, [_c(VTextField, {
    attrs: {
      "data-cy": "tenant_id",
      "value": _vm.$route.params.tenantId,
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.tenantId'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": "",
      "disabled": ""
    }
  })], 1)], 1)], 1)], 1)], 1)], 2)], 2)], 1)], 1)], 1) : _vm._e()], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };